module.exports = __webpack_public_path__ + "img/audio-pause.3ca8d820.svg";